import { createGlobalStyle } from 'styled-components';

export const EventPreviewTooltipStyles = createGlobalStyle`
    .LayerPortal .SuiPopover .SuiTooltipPopover__tip-content--bottom {
        top: 24px;
    }
`;
